import React from 'react'
import { ROUTE, EXPERT_DETAIL_TAB_KEYS } from 'shared-constants'
import styled from 'styled-components'
import { Flex } from 'components/Layout'
import Link from 'components/Link'
import { Tabs } from 'components/Tabs'
import {
  BORDER_WIDTH,
  COLOR_INTENT,
  FONT_SIZE,
  FONT_WEIGHT,
  SPACE,
} from 'Theme'

const EXPERT_DETAIL_TABS = {
  [EXPERT_DETAIL_TAB_KEYS.SHOWROOM]: {
    name: 'Showroom',
    getUrl: ROUTE.FIND_AN_EXPERT_SHOWROOM_TAB_DYNAMIC,
  },
  [EXPERT_DETAIL_TAB_KEYS.CONSULTATION]: {
    name: 'Consultation',
    getUrl: ROUTE.FIND_AN_EXPERT_CONSULTATION_TAB_DYNAMIC,
  },
}

const StyledRoot = styled(Tabs.Root)`
  width: 100%;
  border-bottom: ${BORDER_WIDTH.PX_1} solid ${COLOR_INTENT.TABS.BORDER.BASE};
`

const StyledList = styled(Tabs.List)`
  width: auto;
  border-bottom: none;
  display: flex;
  gap: ${SPACE.PX_32};
`

const StyledTab = styled(Tabs.Tab)`
  width: 100%;
  padding: ${SPACE.PX_10} 0;
  white-space: nowrap;
  font-size: ${FONT_SIZE.PX_16};
  font-weight: ${FONT_WEIGHT.MEDIUM};
  color: ${COLOR_INTENT.TABS.TAB.TEXT.GREY};
`

export interface ExpertTabsProps {
  slug: string
  defaultTab: (typeof EXPERT_DETAIL_TAB_KEYS)[keyof typeof EXPERT_DETAIL_TAB_KEYS]
  tabs: Array<
    (typeof EXPERT_DETAIL_TAB_KEYS)[keyof typeof EXPERT_DETAIL_TAB_KEYS]
  >
}

export const ExpertTabs: React.FC<ExpertTabsProps> = ({
  slug,
  defaultTab,
  tabs,
}) => (
  <StyledRoot defaultValue={defaultTab}>
    <Flex width="100%">
      <StyledList aria-label="Manage sign in account">
        {tabs.map((tabKey) => (
          <StyledTab value={tabKey} key={tabKey} asChild>
            <Link
              href={EXPERT_DETAIL_TABS[tabKey].getUrl({
                slug,
              })}
              scroll={false}
            >
              {EXPERT_DETAIL_TABS[tabKey].name}
            </Link>
          </StyledTab>
        ))}
      </StyledList>
    </Flex>
  </StyledRoot>
)
